import { render, staticRenderFns } from "./TraxUiSearchRemoteObject.vue?vue&type=template&id=0e9fb943&scoped=true"
import script from "./TraxUiSearchRemoteObject.vue?vue&type=script&lang=js"
export * from "./TraxUiSearchRemoteObject.vue?vue&type=script&lang=js"
import style0 from "./TraxUiSearchRemoteObject.vue?vue&type=style&index=0&id=0e9fb943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9fb943",
  null
  
)

export default component.exports